<script setup lang="ts">
import {VBtn} from "vuetify/components";

type VBtnProps = VBtn["$props"];
type VBtnSlots = VBtn["$slots"];

export interface Props extends /* @vue-ignore */ VBtnProps {
    primary?: boolean;
}

const props = defineProps<Props>();
defineSlots<VBtnSlots>();

</script>

<template>
  <v-btn v-bind="props" rounded="xl" :color="props.primary ? 'primary' : props.color ">
    <template v-for="(_, slot) in $slots" #[slot]="slotProps">
      <slot :name="slot" :props="slotProps" :v-bind="$attrs['v-bind']" />
    </template>
  </v-btn>
</template>

<style scoped>
.v-btn {
    text-transform: inherit;
    letter-spacing: inherit;
}

.v-btn--variant-elevated {
    box-shadow: 0 3px 1px -2px rgba(53, 53, 53, 0.16), 0 2px 2px 0 rgba(53, 53, 53, 0.12), 0 1px 5px 0 rgba(53, 53, 53, 0.2);
}
</style>
